export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xovveglb';
export const CALENDLY_URL = 'https://calendly.com/thirtyfivestudio/30min';

export const BUDGET_RANGES = [
  { value: '', label: 'Select a budget range' },
  { value: '1499-6499', label: '$1,499.99 - $6,499.99' },
  { value: '6499-9999', label: '$6,499.99 - $9,999.00' },
  { value: '9999+', label: '$9,999.00+' }
] as const;